import {request} from "@/utils/request";

// 登录
export function loginByAccount(data) {
    return request({
        url:'/login/loginByAccount',
        method:'post',
        data
    })
}

// 注册
export function register(data) {
    return request({
        url:'/login/register',
        method:'post',
        data
    })
}

// 验证码
export function sendZC(data) {
    return request({
        url:'/login/sendZC',
        method:'get',
        params:data
    })
}
